// extracted by mini-css-extract-plugin
export default {"delete_contact_button":"DeleteUserComponent_delete_contact_button__KZ4XL","delete_container":"DeleteUserComponent_delete_container__PBMSA"};